import React, { FC } from "react";

import { DownloadIcon } from "@assets/icons";
import { IconLink } from "@components/IconLink";

interface DownloadexcelLinkProps {
  isCMO: boolean;
}

export const DownloadexcelLink: FC<DownloadexcelLinkProps> = ({ isCMO }) => {
  return (
    <IconLink
      src={DownloadIcon}
      href={isCMO ? "/datafiletemplate_CmoTemplate.csv" : "/datafiletemplate_ResaleRoyaltyTemplate.xlsx"}
      text="Download excel template"
      download
    ></IconLink>
  );
};
